import React, { useEffect, useState } from "react";

export default function Toast({ message, onUndo, onDismiss }) {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  // Animate in on mount
  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
  }, []);

  // Animate out before dismissing
  function handleDismiss() {
    setLeaving(true);
    setTimeout(onDismiss, 300);
  }

  function handleUndo() {
    onUndo();
    handleDismiss();
  }

  return (
    <div
      style={{
        pointerEvents: "all",
        display: "flex",
        alignItems: "center",
        gap: "var(--space-3)",
        background: "var(--text-primary)",
        color: "var(--bg-primary)",
        padding: "var(--space-3) var(--space-4)",
        borderRadius: "var(--radius-lg)",
        boxShadow: "var(--shadow-lg)",
        minWidth: "280px",
        maxWidth: "400px",
        opacity: visible && !leaving ? 1 : 0,
        transform: visible && !leaving
          ? "translateY(0) scale(1)"
          : "translateY(16px) scale(0.95)",
        transition: "opacity 300ms ease, transform 300ms ease",
      }}
    >
      {/* Checkmark icon */}
      <div style={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        background: "var(--accent-green)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
      }}>
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
          <path
            d="M1 4L3.5 6.5L9 1"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Message */}
      <span style={{
        flex: 1,
        fontSize: "14px",
        fontFamily: "var(--font-body)",
        fontWeight: 500,
        color: "var(--bg-primary)"
      }}>
        {message}
      </span>

      {/* Undo button */}
      {onUndo && (
        <button
          onClick={handleUndo}
          style={{
            background: "none",
            border: "none",
            color: "var(--accent-gold-light)",
            fontFamily: "var(--font-body)",
            fontWeight: 600,
            fontSize: "14px",
            cursor: "pointer",
            padding: "var(--space-1) var(--space-2)",
            borderRadius: "var(--radius-sm)",
            flexShrink: 0,
            transition: "opacity var(--transition-fast)"
          }}
          onMouseEnter={e => e.target.style.opacity = "0.7"}
          onMouseLeave={e => e.target.style.opacity = "1"}
        >
          Undo
        </button>
      )}

      {/* Dismiss button */}
      <button
        onClick={handleDismiss}
        style={{
          background: "none",
          border: "none",
          color: "var(--bg-surface-2)",
          cursor: "pointer",
          padding: "var(--space-1)",
          borderRadius: "var(--radius-sm)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: "opacity var(--transition-fast)"
        }}
        onMouseEnter={e => e.target.style.opacity = "0.7"}
        onMouseLeave={e => e.target.style.opacity = "1"}
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path
            d="M1 1L11 11M11 1L1 11"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}